import React from "react";
import { checkDateLabel, parsePayPeriod, payPeriodOptions } from "./payPeriods";

export default function PayPeriodSelect({value,onChange,placeholder="Select pay period",legacyValues=[],...props}) {
  const period=parsePayPeriod(value);
  const selected=period?.start || value || "";
  const previous=[...new Set([...legacyValues,value].filter(item=>item && !parsePayPeriod(item)))];
  const groups=new Map();
  payPeriodOptions(value).forEach(option=>{
    const year=option.start.slice(0,4);
    if(!groups.has(year))groups.set(year,[]);
    groups.get(year).push(option);
  });
  return <div className="shoot-sales-period-select"><select {...props} value={selected} onChange={event=>onChange(event.target.value)}>
    <option value="">{placeholder}</option>
    {[...groups].map(([year,options])=><optgroup key={year} label={year}>{options.map(option=><option key={option.start} value={option.start}>{`${option.label} | Check ${option.checkLabel}`}</option>)}</optgroup>)}
    {previous.length>0 && <optgroup label="Previous entries — need standard period">{previous.map(item=><option key={item} value={item} disabled={!legacyValues.includes(item)}>{item} (previous entry)</option>)}</optgroup>}
  </select>{period && <small>Check date: {checkDateLabel(value)}</small>}</div>;
}
